import React from 'react'
import { navigate } from 'gatsby'
import { useStore } from 'src/state'
import Page from 'src/components/page'
import Container from 'src/components/container'
import HeroSection from 'src/components/hero-section'
import Section from 'src/components/section'
import Link from 'src/components/link'
import Picture from 'src/components/picture'
import AspectBox from 'src/components/aspect-box'
import RichText from 'src/components/rich-text'
import Pagination from 'react-js-pagination'

const PressPage = ({ pageContext }) => {
  const {
    pressPage: { hero },
  } = useStore()
  const { articles, totalPages, pageNumber } = pageContext

  return (
    <Page className="page-press">
      <HeroSection {...hero} />
      <Section className="articles-container">
        <Container>
          <div className="articles">
            {articles.map((article) => (
              <Link className="article" key={article.id} to={article.slug}>
                <div className="image">
                  <AspectBox x={480} y={320}>
                    <Picture image={article.image.src} fitWidth cover />
                  </AspectBox>
                </div>
                <div className="copy">
                  <div className="copy-content">
                    <div className="date">{article.date}</div>
                    <h3 className="title size-medium">{article.title}</h3>
                    <RichText className="summary">{article.summary}</RichText>
                    <div className="more-btn">
                      {article.articleSummaryReadMoreButtonText}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          {totalPages > 1 && (
            <div className="pagination">
              <Pagination
                itemClassFirst="arrow-first"
                itemClassLast="arrow-last"
                itemClassPrev="arrow-prev"
                itemClassNext="arrow-next"
                itemClass="page-item"
                linkClass="page-link"
                hideFirstLastPages
                activePage={pageNumber}
                totalItemsCount={totalPages * 5}
                itemsCountPerPage={5}
                pageRangeDisplayed={5}
                getPageUrl={(page) => `/press/${page > 0 ? page : 1}`}
                onChange={(newPageNumber) => {
                  if (newPageNumber > totalPages) newPageNumber = totalPages
                  navigate(`/press/${newPageNumber}`)
                }}
              />
            </div>
          )}
        </Container>
      </Section>
    </Page>
  )
}

export default PressPage
